import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LinkCopiedToast from '../components/ui/LinkCopiedToast';

const DISMISS_MS = 2200;

export function useLinkCopiedToast() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  const showLinkCopied = useCallback(() => {
    setVisible(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setVisible(false), DISMISS_MS);
  }, []);

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const copyInviteLink = useCallback(async (url, { onError } = {}) => {
    try {
      await navigator.clipboard.writeText(url);
      showLinkCopied();
      return true;
    } catch (err) {
      onError?.(err);
      return false;
    }
  }, [showLinkCopied]);

  const linkCopiedToast = (
    <LinkCopiedToast visible={visible} message={t('common.linkCopied')} />
  );

  return { copyInviteLink, showLinkCopied, linkCopiedToast };
}
